module.exports = __webpack_public_path__ + "static/img/banner_1.efbd98dc.png";